import { legendPositionOptions, LegendPosition } from '../types/legend.js';

/**
 * Returns true if legendPosition is a valid LegendPosition
 * @param legendPosition -
 */
export const isValidLegendPosition = (
  legendPosition: string | undefined,
): legendPosition is LegendPosition =>
  (legendPositionOptions as unknown as string[]).includes(legendPosition ?? '');
